export default {
    init() {
        this.pageEditDropDown();
        this.pageNewLayoutSlider();
    },
    pageEditDropDown(){

    },

    pageNewLayoutSlider(){
        $('.add-page-layout-slider').slick({
            infinite: true,
            slidesToShow: 10,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 8,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 7,
                    }
                },
                {
                    breakpoint: 950,
                    settings: {
                        slidesToShow: 6,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 420,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]
        });
    }

}